export default "__VITE_ASSET__384cc8ef__"